import { action } from 'typesafe-actions';
import { ActionTypes } from './actionTypes';

// Informes horas
export const getInformesHoras = (payload) =>
  action(ActionTypes.GET_INFORMES_HORAS, payload);
export const setInformesHoras = (payload) =>
  action(ActionTypes.SET_INFORMES_HORAS, payload);
export const getInformesHorasCount = (payload) =>
  action(ActionTypes.GET_INFORMES_HORAS_COUNT, payload);
export const setInformesHorasCount = (payload) =>
  action(ActionTypes.SET_INFORMES_HORAS_COUNT, payload);
export const getInformesHorasExcel = (payload) =>
  action(ActionTypes.GET_INFORMES_HORAS_EXCEL, payload);

// Informe horas Instructor

export const getInformesHorasInstructor = (payload) =>
  action(ActionTypes.GET_INFORMES_HORAS_INSTRUCTOR, payload);
export const setInformesHorasInstructor = (payload) =>
  action(ActionTypes.SET_INFORMES_HORAS_INSTRUCTOR, payload);
export const getInformesHorasInstructorCount = (payload) =>
  action(ActionTypes.GET_INFORMES_HORAS_INSTRUCTOR_COUNT, payload);
export const setInformesHorasInstructorCount = (payload) =>
  action(ActionTypes.SET_INFORMES_HORAS_INSTRUCTOR_COUNT, payload);
export const getInformesHorasInstructorExcel = (payload) =>
  action(ActionTypes.GET_INFORMES_HORAS_INSTRUCTOR_EXCEL, payload);

// Informes habilitaciones infraestructura
export const getInformesInfraestructura = (payload) =>
  action(ActionTypes.GET_INFORMES_INFRAESTRUCTURA, payload);
export const setInformesInfraestructura = (payload) =>
  action(ActionTypes.SET_INFORMES_INFRAESTRUCTURA, payload);
export const getInformesInfraestructuraCount = (payload) =>
  action(ActionTypes.GET_INFORMES_INFRAESTRUCTURA_COUNT, payload);
export const setInformesInfraestructuraCount = (payload) =>
  action(ActionTypes.SET_INFORMES_INFRAESTRUCTURA_COUNT, payload);
export const getInformesInfraestructuraExcel = (payload) =>
  action(ActionTypes.GET_INFORMES_INFRAESTRUCTURA_EXCEL, payload);

// Filttros
export const getSociedadesInformes = (payload) =>
  action(ActionTypes.GET_SOCIEDADES_INFORMES, payload);
export const setSociedadesInformes = (payload) =>
  action(ActionTypes.SET_SOCIEDADES_INFORMES, payload);

export const getProvinciasInformes = (payload) =>
  action(ActionTypes.GET_PROVINCIAS_INFORMES, payload);
export const setProvinciasInformes = (payload) =>
  action(ActionTypes.SET_PROVINCIAS_INFORMES, payload);

export const getEstadosInformes = (payload) =>
  action(ActionTypes.GET_ESTADOS_INFORMES, payload);
export const setEstadosInformes = (payload) =>
  action(ActionTypes.SET_ESTADOS_INFORMES, payload);

export const getInformesCursosFilter = (payload) =>
  action(ActionTypes.GET_CURSOS_INFORMES, payload);
export const setInformesCursosFilter = (payload) =>
  action(ActionTypes.SET_CURSOS_INFORMES, payload);

export const getAlumnosInforme = (payload) =>
  action(ActionTypes.GET_ALUMNOS_INFORMES, payload);
export const setAlumnosInforme = (payload) =>
  action(ActionTypes.SET_ALUMNOS_INFORMES, payload);

export const removeInformeFiltros = () =>
  action(ActionTypes.REMOVE_FILTERS_INFORMES);

// Cache
export const setAllInformesCursosFilter = (payload) =>
  action(ActionTypes.SET_ALL_INFORMES_CURSOS_FILTER, payload);
